module.exports = __webpack_public_path__ + "img/paysafe.14a67b89.svg";